var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsChannel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b7ef2",
    d: "M10.991 2A9 9 0 1 0 20 11a9 9 0 0 0-9.009-9zm6.237 5.4h-2.655a14.084 14.084 0 0 0-1.242-3.2 7.227 7.227 0 0 1 3.897 3.2zM11 3.836A12.678 12.678 0 0 1 12.719 7.4H9.281A12.678 12.678 0 0 1 11 3.836zM4.034 12.8a7.04 7.04 0 0 1 0-3.6h3.042A14.864 14.864 0 0 0 6.95 11a14.864 14.864 0 0 0 .126 1.8zm.738 1.8h2.655a14.084 14.084 0 0 0 1.242 3.2 7.188 7.188 0 0 1-3.9-3.2zm2.655-7.2H4.772a7.188 7.188 0 0 1 3.9-3.2 14.084 14.084 0 0 0-1.245 3.2zM11 18.164A12.678 12.678 0 0 1 9.281 14.6h3.438A12.678 12.678 0 0 1 11 18.164zm2.106-5.364H8.894A13.241 13.241 0 0 1 8.75 11a13.126 13.126 0 0 1 .144-1.8h4.212a13.127 13.127 0 0 1 .144 1.8 13.242 13.242 0 0 1-.144 1.8zm.225 5a14.084 14.084 0 0 0 1.242-3.2h2.655a7.227 7.227 0 0 1-3.897 3.2zm1.593-5a14.864 14.864 0 0 0 .126-1.8 14.864 14.864 0 0 0-.126-1.8h3.042a7.04 7.04 0 0 1 0 3.6z",
    transform: "translate(-1341 -369) translate(1342 370)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsChannel);
export default __webpack_public_path__ + "static/media/webs_channel.2f7ace87eb4ee929d178e8c94113175a.svg";
export { ForwardRef as ReactComponent };